import { render, staticRenderFns } from "./AmlAddBlackSidebar.vue?vue&type=template&id=68673c26&"
import script from "./AmlAddBlackSidebar.vue?vue&type=script&lang=js&"
export * from "./AmlAddBlackSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AmlAddBlackSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports